module.exports = __webpack_public_path__ + "img/toogle-menu.653f2cf4.svg";